// extracted by mini-css-extract-plugin
export default {"video":"homehead_video__y0LZc","head":"homehead_head__-r7AO","info":"homehead_info__Quogh","scroll":"homehead_scroll__Vkfnh"};